import Modal from 'components/commons/modal/Modal2';
import React, { useState } from 'react';
import { SNS, snsToString } from './SNS';

const Base = ({
  hide,
  isShow,
  sns,
  onCancel,
  toTitle,
  onYes,
  content,
}: {
  isShow: boolean;
  hide: () => void;
  sns: SNS;
  onYes: () => Promise<void>;
  onCancel: () => void;
  toTitle: (sns: SNS) => string;
  content: string;
}) => {
  const [state, setState] = useState<'Ready' | 'Hitting' | 'Done'>('Ready');
  const onClickYes = async () => {
    setState('Hitting');
    await onYes();
    setState('Done');
  };
  return (
    <>
      <Modal
        {...{
          isShow,
          close: hide,
          closeOnClickOutsideWindow: true,
        }}>
        <div className="p-4">
          <div className="flex flex-row">
            <div
              className="ml-auto icon-close text-md cursor-pointer"
              onClick={hide}></div>
          </div>
          <div className="flex flex-row mt-2 font-bold text-lg text-bluegray-700">
            {toTitle(sns)}
          </div>
          <div className="mt-4">{content}</div>
          <div className="p-4 flex flex-col gap-4 mt-4">
            {state === 'Hitting' && (
              <div className="bg-white flex flex-row items-center justify-center">
                <img
                  src="/static/images/loading/spin-gray.svg"
                  alt="ローディング"
                  className={``}
                />
              </div>
            )}
            <button
              className="bg-tradewell rounded-lg font-bold text-white p-2"
              onClick={onClickYes}>
              はい
            </button>
            <button className="bg-white rounded-lg p-2" onClick={onCancel}>
              キャンセル
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export const LinkConfirmModal = ({
  hide,
  isShow,
  sns,
  onCancel,
  onClickSNSLink,
}: {
  isShow: boolean;
  hide: () => void;
  sns: SNS;
  onClickSNSLink: () => Promise<void>;
  onCancel: () => void;
}): React.ReactElement => {
  return (
    <>
      <Base
        {...{
          content:
            'シェアするには連携先のSNSサイトでログインしてアクセスの許可を行ってください。',
          hide,
          isShow,
          onCancel,
          onYes: onClickSNSLink,
          sns,
          toTitle: sns => `${snsToString(sns)}のサイトへ移動します`,
        }}
      />
    </>
  );
};

export const UnlinkConfirmModal = ({
  hide,
  isShow,
  onCancel,
  onUncertificate,
  sns,
}: {
  isShow: boolean;
  hide: () => void;
  sns: SNS;
  onUncertificate: () => Promise<void>;
  onCancel: () => void;
}): React.ReactElement => {
  return (
    <>
      <Base
        {...{
          content: `${snsToString(
            sns
          )}アカウントとの連携を解除します。よろしいですか？`,
          hide,
          isShow,
          onCancel,
          onYes: onUncertificate,
          sns,
          toTitle: sns => `${snsToString(sns)}との連携を解除します`,
        }}
      />
    </>
  );
};
